<template>
  <div class="RoomSettings">

    <div>

      <h3>Personal settings</h3>

      <label>
        <span>Name</span>
        <input v-model="nameTemp" maxlength="32" @change="updateName()" placeholder="Your name"/>
      </label>

      <label>
        <span>Mood</span>
        <MoodSelector></MoodSelector>
      </label>
    </div>

    <hr />

    <div>

      <h3>Speech-to-text settings</h3>
      <div class="">
        <div v-if="speech.data.support">

          <label>
          <span>Language</span>
          <select v-model="language" >
            <option disabled value="null">
              Choose language
            </option>
            <option v-for="l in languages" :key="l.code" :value="l.code">
              {{l.name}}
            </option>
          </select>
          </label>
          <label>
            <span>Send messages</span>
          </label>
          <button v-if="!speech.data.running" @click="ttsStart">Start speaking</button>
          <button v-else @click="ttsStop" class="red">Stop speaking</button>

        </div>
        <div v-else>
          Your browser does not support text-to-speech. Try <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a>.
        </div>
      </div>
    </div>
      <!--div class="screenSmall">
        Use Textify on the desktop computer to send messages with your voice.
      </div-->

  </div>
</template>

<script>

import MoodSelector from '@/components/MoodSelector.vue'

import { mapState } from 'vuex'

export default {
  name: 'Settings',
  components: {
    MoodSelector
  },
  data: function () {
    return {
      nameTemp: "",
    }
  },
  props: {
  },
  computed: {
    ...mapState('speech',[
      'speech',
      'languages'
    ]),
    name: {
      get () { return this.$store.state.user.name},
      set () {
      }
    },
    language: {
      get () { return this.speech.data.language},
      set (value) {
        this.$store.dispatch('speech/setLanguage', {language: value})
      }
    },
  },
  methods: {
    updateName: function (){
      this.$store.dispatch('user/setName', {name: this.nameTemp})
    },
    ttsStart: function () {
      this.$store.dispatch('speech/start')
    },
    ttsStop: function () {
      this.$store.dispatch('speech/stop')
    },
  },
  mounted: function () {
    this.nameTemp = this.name;
  },
  beforeDestroy: function () {
    this.ttsStop();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.RoomSettings{
}

input, select{
  width: 100%;
}

</style>
